import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

function getTeamUsersHelper(teamId: number) {
  return clientApi.getOCClient().helpers.employer.teams.id(teamId).users;
}

const { useFind: useTeamUsers } = getCRUDHooks({
  entityName: 'teamUser',
  find: ({ teamId, filters }) => getTeamUsersHelper(teamId).find(filters),
});

// eslint-disable-next-line import/prefer-default-export
export { useTeamUsers };
